import { connect }        from 'react-redux';
import Errors             from '../../../errors';
import SuccessString      from '../../../success';
import { sendContact }    from './contact-dux';
import { dismissError }   from '../../../errors-dux';
import { dismissSuccess } from '../../../success-dux';
import Contact            from './contact.jsx';


export default connect(
        // mapStateToProps
        state => ( {
            emailAddress: state.userData.emailAddress,
            busy: state.contactUsData.busy,
            done: state.successData.done,
            contactErrors: Errors.getByType( state, Errors.ERROR_CONTACTUS_SUBMISSION_FAILED ),
            contactSuccessMessage: SuccessString.getByType( state, SuccessString.SUCCESS_CONTACT_US )
        } ),
        {
            sendContact,
            dismissError,
            dismissSuccess
        } // mapDispatchToProps
)( Contact );
